<template>
  <div class="popup-wrapper" @click.self="action.close">
    <div class="popup-action">
      <div class="button button-close">
        <button class="btn" @click="action.close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">パーツの配置</span>
        </div>
        <div class="popup-content">
          <ul class="popup-content-list">
            <li v-if="index !== 0" @click="action.move('top')" class="popup-content-list-item">
              最上位に移動
            </li>
            <li v-if="index !== 0" @click="action.move('up')" class="popup-content-list-item">
              一つ上に移動
            </li>
            <li v-if="index !== length" @click="action.move('down')" class="popup-content-list-item">
              一つ下に移動
            </li>
            <li v-if="index !== length" @click="action.move('bottom')" class="popup-content-list-item">
              最下位に移動
            </li>
          </ul>
          <p v-if="length === 0" class="txt">パーツの位置変更には2個以上のパーツが必要です。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'SPNotePartMove',
  props: {
    index: {
      type: Number,
      default: 0
    },
    length: {
      type: Number,
      default: 0
    }
  },
  setup (props, context) {
    const action = reactive({
      close: () => context.emit('close'),
      move: (param) => {
        const move = (() => {
          switch (param) {
            case 'top': return 0
            case 'up': return props.index - 1
            case 'down': return props.index + 1
            case 'bottom': return props.length
            default: return false
          }
        })()
        context.emit('move', move)
      }
    })

    return {
      action
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    &-list {
      &-item {
        border-bottom: 1px solid $color-line;
        color: $color-link;
        font-size: 1.6rem;
        padding: 20px 16px;
      }
    }
    .txt {
      padding: 20px;
    }
  }
  &-action {
    width: auto;
    left: auto;
    right: 0;
    border-top-left-radius: 8px;
    .btn {
      height: 78px;
    }
  }
}


</style>
